/* PlanJapon V2 — moteur panier v4 (2026-09-24)

   Une action = UNE requête. Mesuré depuis Bangkok avant la refonte : 4,05 s entre le clic
   « Ajouter au panier » et l'ouverture du tiroir, cinq allers-retours en file (ajout,
   relecture, ajout des cadeaux, relecture, re-rendu) ; jusqu'à sept pour retirer la
   dernière eSIM. Chaque mutation coûte 0,4 à 1,8 s de traitement chez Shopify : on ne
   peut pas l'accélérer, seulement n'en faire qu'une.

   - Le rendu du tiroir revient DANS la réponse de la mutation (paramètre `sections`,
     rendu dans le contexte de la page : langue et marché justes).
   - Les cadeaux (guide + carte) partent dans la même requête que l'eSIM, et sortent
     dans la même requête que la dernière eSIM. L'état nécessaire est lu sur #pjDrawer
     (data-*), rendu par sections/cart-drawer.liquid.
   - L'interface répond tout de suite (quantité, retrait, tiroir ouvert) ; les montants
     restent grisés jusqu'à la réponse, seul Shopify sait les calculer.
   - Les mutations passent en file, dans l'ordre ; le tiroir n'est remplacé que par la
     DERNIÈRE réponse, qui porte l'état final (pas de clignotement sur des clics rapides).
   - Codes promo : `discount` de /cart/update.js — la liste envoyée REMPLACE celle du panier.

   Événement `pj:cart:updated` (detail : item_count, total_price, units, attributes, codes)
   après chaque rendu : pj-money-convert, pj-order-locale, pj-ref-affiliation, data-calculator. */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var noop = function () {};

  var drawer = function () { return document.getElementById('pjDrawer'); };
  var data = function () { var d = drawer(); return d ? d.dataset : {}; };
  var list = function (s) { return String(s || '').split(',').filter(Boolean); };
  var nums = function (s) { return list(s).map(Number).filter(Boolean); };
  var isOpen = function () { var d = drawer(); return !!d && !d.hidden; };
  var t = function (k) { return data()[k] || ''; };

  /* Codes refusés par Shopify (non cumulables, expirés, inconnus) : Liquid ne les voit pas,
     seul le JSON panier les liste. Conservés ici et réaffichés après chaque rendu. */
  var naCodes = [];

  /* ---- Annonces pour lecteurs d'écran (hors du tiroir, qui est remplacé) ------------ */
  var live;
  function say(msg) {
    if (!msg) return;
    if (!live) {
      live = document.createElement('p');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;margin:-1px';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 40);
  }

  /* ---- Ouverture / fermeture : instantanées, sans réseau ----------------------------- */
  function openDrawer() {
    var d = drawer();
    if (!d || (!d.hidden && d.classList.contains('is-open'))) return;
    d.hidden = false;
    /* Reflow forcé plutôt que requestAnimationFrame : la transition part quand même, et
       l'ouverture ne dépend plus d'une image affichée (onglet en arrière-plan, appareil lent). */
    void d.offsetWidth;
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var x = d.querySelector('[data-drawer-close-btn]');
    if (x) x.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { var cur = drawer(); if (cur && !cur.classList.contains('is-open')) cur.hidden = true; }, 260);
  }

  /* ---- Remplacement du tiroir par un rendu frais -------------------------------------- */
  function focusMark(el, root) {
    if (!el || !root.contains(el)) return null;
    var host = el.closest('[data-focus-key]');
    var attrs = ['data-step', 'data-remove', 'data-code-toggle', 'data-code-remove', 'data-upsell-vid'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) {
        return { key: host ? host.getAttribute('data-focus-key') : '', attr: attrs[i], val: el.getAttribute(attrs[i]) };
      }
    }
    return null;
  }

  function renderNa(d) {
    var ul = d && d.querySelector('[data-code-na]');
    if (!ul) return;
    ul.textContent = '';
    naCodes.forEach(function (code) {
      var li = document.createElement('li');
      var b = document.createElement('b');
      b.textContent = code;
      li.appendChild(document.createTextNode('🏷 '));
      li.appendChild(b);
      li.appendChild(document.createTextNode(' · ' + (d.dataset.tCodeNa || '')));
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'pj-sum__rm';
      x.setAttribute('data-code-remove', code);
      x.setAttribute('aria-label', (d.dataset.tCodeRm || '') + ' ' + code);
      x.textContent = '✕';
      li.appendChild(x);
      ul.appendChild(li);
    });
    ul.hidden = !naCodes.length;
  }

  function swap(html) {
    if (!html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#pjDrawer');
    var cur = drawer();
    if (!fresh || !cur) return false;

    var open = isOpen();
    var form = cur.querySelector('[data-code-form]');
    var inp = form && form.querySelector('input');
    var codeOpen = !!form && !form.hidden;
    var codeVal = inp ? inp.value : '';
    var codeFocus = !!inp && document.activeElement === inp;
    var body = cur.querySelector('.pj-drawer__body');
    var top = body ? body.scrollTop : 0;
    var mark = focusMark(document.activeElement, cur);

    if (open) { fresh.hidden = false; fresh.classList.add('is-open', 'no-anim'); }
    cur.replaceWith(fresh);

    var nb = fresh.querySelector('.pj-drawer__body');
    if (nb) nb.scrollTop = top;
    var nf = fresh.querySelector('[data-code-form]');
    if (nf && codeOpen) {
      nf.hidden = false;
      var tg = fresh.querySelector('[data-code-toggle]');
      if (tg) tg.setAttribute('aria-expanded', 'true');
      var ni = nf.querySelector('input');
      if (ni) { ni.value = codeVal; if (codeFocus) ni.focus({ preventScroll: true }); }
    }
    if (mark) {
      var sel = '[' + mark.attr + (mark.val ? '="' + mark.val.replace(/"/g, '\\"') + '"' : '') + ']';
      var scope = mark.key ? fresh.querySelector('[data-focus-key="' + mark.key.replace(/"/g, '\\"') + '"]') : fresh;
      var target = (scope && scope.querySelector(sel)) || fresh.querySelector('[data-drawer-close-btn]');
      if (target) target.focus({ preventScroll: true });
    }
    renderNa(fresh);
    if (open) requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.classList.remove('no-anim'); }); });
    return true;
  }

  function state() {
    var d = data(), attrs = {};
    try { attrs = JSON.parse(d.attrs || '{}'); } catch (e) {}
    return {
      item_count: +d.count || 0,
      total_price: +d.total || 0,
      units: +d.units || 0,
      attributes: attrs,
      codes: list(d.codes)
    };
  }

  function updateBadge(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-cart-chip]').forEach(function (el) { el.toggleAttribute('hidden', n === 0); });
  }

  /* Après chaque rendu : pastille, événement, contrôle des cadeaux. */
  function settle() {
    var d = drawer();
    if (d) d.classList.remove('is-busy');
    var s = state();
    updateBadge(s.item_count);
    document.dispatchEvent(new CustomEvent('pj:cart:updated', { detail: s }));
    verifyGifts();
  }

  /* ---- Mutations : en file, rendu dans la réponse ------------------------------------ */
  var chain = Promise.resolve();
  var inflight = 0;

  /* Délai maximal par requête : les mutations passent en file, une seule requête bloquée
     (réseau mobile qui décroche) gèlerait toutes les suivantes — le client cliquerait
     dans le vide. Au-delà, on abandonne et le tiroir se resynchronise. */
  var TIMEOUT_MS = 20000;

  function post(endpoint, body) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, TIMEOUT_MS) : null;
    var done = function () { if (timer) clearTimeout(timer); };
    return fetch(ROOT + 'cart/' + endpoint + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        done();
        if (!r.ok) {
          var err = new Error(j.description || j.message || ('HTTP ' + r.status));
          err.status = r.status;
          throw err;
        }
        return j;
      });
    }, function (e) { done(); throw e; });
  }

  function mutate(endpoint, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    inflight++;
    var d = drawer();
    if (d) d.classList.add('is-busy');
    var run = function () { return post(endpoint, body); };
    var p = chain.then(run, run);
    chain = p.then(noop, noop);
    return p.then(function (j) {
      inflight--;
      if (Array.isArray(j.discount_codes)) {
        naCodes = j.discount_codes.filter(function (c) { return !c.applicable; }).map(function (c) { return c.code; });
      }
      if (inflight === 0) {
        if (swap(j.sections && j.sections[SECTION])) settle();
        else resync();
      }
      return j;
    }, function (err) {
      inflight--;
      if (inflight === 0) resync();
      throw err;
    });
  }

  /* Rendu frais sans mutation : après une erreur, un retour arrière (bfcache), ou si le
     panier a changé ailleurs (autre onglet). Contexte de la page courante → bonne langue. */
  function resync() {
    return fetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (swap(j[SECTION])) settle(); })
      .catch(function () { var d = drawer(); if (d) d.classList.remove('is-busy'); });
  }

  /* ---- Cadeaux ------------------------------------------------------------------------ */
  function giftQty() {
    var out = {};
    list(data().giftLines).forEach(function (p) { var kv = p.split(':'); out[+kv[0]] = +kv[1] || 0; });
    return out;
  }

  /* Filet : l'état lu avant la mutation peut être périmé (autre onglet). Une seule
     correction par action du client — jamais de boucle si un cadeau devient indisponible. */
  var healing = 0;
  function verifyGifts() {
    var d = data();
    var gifts = nums(d.gifts);
    if (!gifts.length || inflight || healing > 0) return;
    var have = giftQty();
    var needed = (+d.esimQty || 0) > 0;
    var add = [], updates = {}, n = 0;
    if (needed) {
      gifts.forEach(function (g) {
        if (!have[g]) add.push({ id: g, quantity: 1 });
        else if (have[g] > 1) { updates[g] = 1; n++; }
      });
    } else {
      list(d.giftKeys).forEach(function (k) { updates[k] = 0; n++; });
    }
    if (!add.length && !n) return;
    healing++;
    (add.length ? mutate('add', { items: add }) : mutate('update', { updates: updates })).catch(noop);
  }

  /* ---- Lignes du tiroir : quantité, retrait, +1 voyageur ------------------------------ */
  function tripLines(li) {
    var tk = li.getAttribute('data-trip-keys');
    if (!tk) return [li];
    return Array.prototype.filter.call(drawer().querySelectorAll('[data-line]'), function (x) {
      return x.getAttribute('data-trip-keys') === tk;
    });
  }

  function setLineQty(li, target) {
    target = Math.max(0, target);
    var cur = +li.dataset.q || 0;
    if (target === cur) return;
    healing = 0;
    var d = drawer();
    var tripKeys = list(li.dataset.tripKeys);
    var keys = list(li.dataset.keys);
    var updates = {};
    /* Séjour découpé : +1 voyageur = +1 eSIM de CHAQUE tranche ; retirer = tout le voyage. */
    if (tripKeys.length) tripKeys.forEach(function (k) { updates[k] = target; });
    else keys.forEach(function (k, i) { updates[k] = i === 0 ? target : 0; });

    var units = tripKeys.length || 1;
    var esimAfter = (+d.dataset.esimQty || 0) + (li.dataset.esim ? (target - cur) * units : 0);
    if (li.dataset.esim && esimAfter <= 0) {
      list(d.dataset.giftKeys).forEach(function (k) { updates[k] = 0; });
    }
    d.dataset.esimQty = Math.max(0, esimAfter);

    tripLines(li).forEach(function (x) {
      x.dataset.q = target;
      var v = x.querySelector('[data-qty-val]');
      if (v) v.textContent = target;
      x.classList.add(target === 0 ? 'is-removing' : 'is-busy');
    });
    if (li.dataset.esim && esimAfter <= 0) {
      var g = d.querySelector('[data-gift-row]');
      if (g) g.classList.add('is-removing');
    }
    mutate('update', { updates: updates }).catch(function () { say(t('tError')); });
  }

  /* Tiroir de l'ANCIENNE version (data-vset / data-qty / data-upsell-add, sans data-line) :
     il peut encore arriver dans une page qui tourne avec ce script — cookie de préview qui
     expire, rendu servi par l'ancien thème pendant une bascule. Ses boutons doivent rester
     vivants : on les pilote par variante, en une requête, sans l'optimisme des lignes v4. */
  function legacySet(btn) {
    healing = 0;
    var target = Math.max(0, parseInt(btn.getAttribute('data-target'), 10) || 0);
    var vids = nums(btn.getAttribute('data-vids') || btn.getAttribute('data-vid'));
    if (!vids.length) return;
    var updates = {};
    vids.forEach(function (id) { updates[id] = target; });
    btn.classList.add('is-loading');
    mutate('update', { updates: updates }).catch(function () { say(t('tError')); });
  }

  /* ---- Codes promo -------------------------------------------------------------------- */
  function codeMsg(text, kind) {
    var p = drawer() && drawer().querySelector('[data-code-msg]');
    if (!p) return;
    p.textContent = text || '';
    p.className = 'pj-code__msg' + (kind ? ' is-' + kind : '');
    p.hidden = !text;
    say(text);
  }

  function currentCodes() {
    var seen = {}, out = [];
    list(data().codes).concat(naCodes).forEach(function (c) {
      var k = c.toUpperCase();
      if (!seen[k]) { seen[k] = 1; out.push(c); }
    });
    return out;
  }

  function applyCode(form) {
    var inp = form.querySelector('input');
    var code = (inp && inp.value || '').replace(/\s+/g, '').toUpperCase();
    if (!code) { if (inp) inp.focus(); return; }
    healing = 0;
    var others = currentCodes().filter(function (c) { return c.toUpperCase() !== code; });
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    mutate('update', { discount: others.concat(code).join(',') })
      .then(function (j) {
        var hit = (j.discount_codes || []).filter(function (c) { return String(c.code).toUpperCase() === code; })[0];
        if (hit && hit.applicable) {
          /* Accepté : le code a désormais sa ligne 🏷 dans le détail — on replie le champ,
             le pied reste court (sur un petit écran, il se prend sur la liste). */
          var nf = drawer() && drawer().querySelector('[data-code-form]');
          if (nf) {
            nf.querySelector('input').value = '';
            nf.hidden = true;
            var tg = drawer().querySelector('[data-code-toggle]');
            if (tg) tg.setAttribute('aria-expanded', 'false');
          }
          codeMsg(t('tCodeOk'), 'ok');
          return;
        }
        /* Code tapé et refusé : on le retire aussitôt (sinon il resterait listé), et on le
           laisse dans le champ pour que le client corrige une faute de frappe. */
        return mutate('update', { discount: others.join(',') }).then(function () {
          var ni2 = drawer() && drawer().querySelector('[data-code-form] input');
          if (ni2) { ni2.value = code; ni2.focus({ preventScroll: true }); }
          codeMsg(t('tCodeBad'), 'err');
        });
      }, function () { codeMsg(t('tError'), 'err'); })
      .catch(function () { codeMsg(t('tError'), 'err'); })
      .then(function () {
        var b = drawer() && drawer().querySelector('[data-code-form] [type="submit"]');
        if (b) b.classList.remove('is-loading');
      });
  }

  function removeCode(code, el) {
    if (el) el.classList.add('is-loading');
    healing = 0;
    var next = currentCodes().filter(function (c) { return c.toUpperCase() !== String(code).toUpperCase(); });
    /* Un code venu d'un lien /discount/CODE vit aussi dans un cookie : sans ce ménage,
       le checkout pourrait le réappliquer. */
    if (new RegExp('(?:^|; )discount_code=' + String(code).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:;|$)', 'i').test(document.cookie)) {
      document.cookie = 'discount_code=; Max-Age=0; path=/';
    }
    mutate('update', { discount: next.join(',') }).then(function () { codeMsg(''); }, function () { codeMsg(t('tError'), 'err'); });
  }

  function toggleCode() {
    var d = drawer();
    var f = d && d.querySelector('[data-code-form]');
    var tg = d && d.querySelector('[data-code-toggle]');
    if (!f) return;
    f.hidden = !f.hidden;
    if (tg) tg.setAttribute('aria-expanded', String(!f.hidden));
    if (!f.hidden) { var i = f.querySelector('input'); if (i) i.focus(); }
  }

  /* ---- Ajout au panier depuis une fiche produit --------------------------------------- */
  function formItems(f) {
    var fd = new FormData(f);
    var it = { id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) || 1 };
    var props = {}, hasProps = false;
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && v !== '') { props[m[1]] = v; hasProps = true; }
    });
    if (hasProps) it.properties = props;
    var sp = fd.get('selling_plan');
    if (sp) it.selling_plan = +sp;
    return [it];
  }

  function showPending() {
    var d = drawer();
    if (!d) return;
    var empty = d.querySelector('[data-cart-empty]');
    if (empty) empty.classList.add('is-hidden');
    var ul = d.querySelector('[data-lines]');
    if (!ul || ul.querySelector('.pj-line--pending')) return;
    var li = document.createElement('li');
    li.className = 'pj-line pj-line--pending';
    li.innerHTML = '<span class="pj-line__img"></span><div class="pj-line__mid"><b class="pj-line__title"></b></div>';
    li.querySelector('b').textContent = d.dataset.tAdding || '…';
    ul.insertBefore(li, ul.firstChild);
    d.classList.add('is-busy');
  }

  function atcError(f, msg) {
    var box = f.querySelector('[data-pj-atc-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'atc-err';
      box.setAttribute('data-pj-atc-error', '');
      f.appendChild(box);
    }
    box.textContent = f.dataset.pjError || msg || '';
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-code-form]')) { e.preventDefault(); applyCode(f); return; }
    if (!f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    healing = 0;
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var old = f.querySelector('[data-pj-atc-error]');
    if (old) old.textContent = '';

    /* Séjour de plus de 30 jours : la fiche produit fournit la liste complète des eSIM en
       JSON (le form natif ne sait poster qu'une variante). */
    var multi = f.dataset.pjItems;
    var items = multi ? JSON.parse(multi) : formItems(f);
    var d = data();
    var esimVids = nums(d.esimVids);
    var have = giftQty();
    var withEsim = items.some(function (it) { return esimVids.indexOf(+it.id) !== -1; });
    var giftItems = withEsim
      ? nums(d.gifts).filter(function (g) { return !have[g]; }).map(function (g) { return { id: g, quantity: 1 }; })
      : [];

    openDrawer();
    showPending();
    mutate('add', { items: items.concat(giftItems) })
      .catch(function (err) {
        /* Un cadeau indisponible ne doit jamais bloquer la vente : on retente sans lui. */
        if (giftItems.length && err.status === 422) return mutate('add', { items: items });
        throw err;
      })
      .catch(function (err) {
        var li = drawer() && drawer().querySelector('.pj-line--pending');
        if (li) li.remove();
        if (!err.status && !multi) { f.submit(); return; } /* réseau : repli sur la page /cart */
        closeDrawer();
        atcError(f, err.message);
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---- Contrôles délégués ------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (el.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var opener = el.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(); return; }

    var step = el.closest('[data-step]');
    if (step) {
      var li = step.closest('[data-line]');
      if (li) setLineQty(li, (+li.dataset.q || 0) + (+step.getAttribute('data-step') || 0));
      else if (step.hasAttribute('data-vset')) legacySet(step);
      return;
    }
    var rm = el.closest('[data-remove]');
    if (rm) {
      var li2 = rm.closest('[data-line]');
      if (li2) setLineQty(li2, 0);
      else if (rm.hasAttribute('data-vset')) legacySet(rm);
      return;
    }
    var up = el.closest('[data-upsell-vid]');
    if (up) {
      var li3 = drawer().querySelector('[data-line][data-vid="' + up.getAttribute('data-upsell-vid') + '"]:not([data-trip-keys])');
      if (li3) { up.classList.add('is-loading'); setLineQty(li3, (+li3.dataset.q || 0) + 1); }
      else addOne(up, up.getAttribute('data-upsell-vid'));
      return;
    }
    if (el.closest('[data-code-toggle]')) { toggleCode(); return; }
    var cr = el.closest('[data-code-remove]');
    if (cr) { removeCode(cr.getAttribute('data-code-remove'), cr); return; }

    /* Ancien tiroir (cf. legacySet) */
    var vs = el.closest('[data-vset]');
    if (vs) { legacySet(vs); return; }
    var qb = el.closest('[data-qty]');
    if (qb && qb.getAttribute('data-key')) {
      healing = 0;
      qb.classList.add('is-loading');
      var u = {};
      u[qb.getAttribute('data-key')] = Math.max(0, parseInt(qb.getAttribute('data-qty'), 10) || 0);
      mutate('update', { updates: u }).catch(function () { say(t('tError')); });
      return;
    }
    var ua = el.closest('[data-upsell-add]');
    if (ua) addOne(ua, ua.getAttribute('data-upsell-add'));
  });

  function addOne(btn, vid) {
    healing = 0;
    btn.classList.add('is-loading');
    mutate('add', { items: [{ id: +vid, quantity: 1 }] }).catch(function () { say(t('tError')); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeDrawer();
  });

  /* ---- Fraîcheur : le tiroir rendu avec la page peut dater (retour arrière, autre onglet).
     Une lecture de /cart.js (≈ 60 ms côté Shopify, sans verrou) ; re-rendu seulement si
     quelque chose a changé. */
  function codesKey(arr) { return arr.map(function (c) { return String(c).toUpperCase(); }).sort().join(','); }
  function freshen() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        naCodes = (c.discount_codes || []).filter(function (x) { return !x.applicable; }).map(function (x) { return x.code; });
        var applied = (c.discount_codes || []).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; });
        var d = data();
        updateBadge(c.item_count);
        var stale = String(c.item_count) !== String(d.count) || String(c.total_price) !== String(d.total) ||
          codesKey(applied) !== codesKey(list(d.codes));
        if (stale) return resync();
        renderNa(drawer());
        /* Cadeaux restés seuls (eSIM retirée ailleurs, ancienne version) : aucun bouton ne
           permet au client de les enlever — on les retire ici, une fois. */
        verifyGifts();
      })
      .catch(noop);
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) freshen(); });
  freshen();
})();
